import {useSelector} from "react-redux"
import ProductDetails from "../ProductDetails"
import { Switch } from "@mui/material";
import EditableLabel from "../EditableLabel";
/**
 * 
const DEFAULT_PRODUCT_ADDON_CONFIG = {
    id: "",
    productId: "",
    productName: "",
    groupLabel: "",
    useProductNameAsLabel: true,
    required: false,
    selectMultiple: false,
    selectMax: null,
    selectMin: null,
    addToPrice: true,
    allAddonsOnAllVariants: true,
    allowedAddonVariantsByProductVariantId: {}
}
 */
const ProductAddonConfigListItem = ({addonConfig, onChange=()=>{}}) => {
    const payeeProductsById = useSelector(state => state.payeeProducts.payeeProductsById || {})
    if (!addonConfig) return null
    const {productId="", required, addToPrice, selectMultiple, useProductNameAsLabel, productName="", groupLabel=""} = addonConfig
    if (!productId) return null
    const payeeProduct = payeeProductsById[productId]
    const {variantsById={}} = payeeProduct || {}
    return (
        <div>
            {
                payeeProduct ?
                <ProductDetails 
                    product={payeeProduct} 
                    showDescription={false} 
                    showVariants={false}
                />
                :
                null
            }
            <div className="label display-flex align-items-center">
                <Switch 
                    checked={useProductNameAsLabel}
                    color="success"
                    onChange={() => onChange({
                        ...addonConfig, 
                        useProductNameAsLabel: !useProductNameAsLabel,
                        groupLabel: useProductNameAsLabel ? productName : groupLabel
                    })}
                />
                <div>
                    {
                        useProductNameAsLabel? 
                        "Use product name as label" : 
                        <div className="display-flex align-items-center">
                            <div className="font-weight-600">Edit:</div>
                            <div className="margin-left-5px font-size-14px border-width-1px border-style-outset border-radius-4px padding-5px">
                            <EditableLabel
                                label={groupLabel}
                                onChange={groupLabel => onChange({...addonConfig, groupLabel})}
                                validate={groupLabel => Boolean(String(groupLabel).trim())}
                                inputStyle={{fontSize: 13, maxWidth: 120, padding: 2}}
                            />
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className="label display-flex align-items-center">
                <Switch 
                    checked={required}
                    color="success"
                    onChange={() => onChange({...addonConfig, required: !required})}
                />
                <div>
                    {required? "Required" : "Optional"}
                </div>
            </div>
            <div className="label display-flex align-items-center">
                <Switch 
                    checked={addToPrice}
                    color="success"
                    onChange={() => onChange({...addonConfig, addToPrice: !addToPrice})}
                />
                <div>
                    {addToPrice? "Increases order total when chosen" : "Doesn't change order total"}
                </div>
            </div>
            {/* you can only choose multiple options on products with multiple variants */}
            {
                Object.keys(variantsById).length > 1 ?
                <div className="label display-flex align-items-center">
                    <Switch 
                        checked={selectMultiple}
                        color="success"
                        onChange={() => onChange({...addonConfig, selectMultiple: !selectMultiple})}
                    />
                    <div>
                        {selectMultiple? "Select multiple options" : "No, select 1 option"}
                    </div>
                </div>
                :
                null
            }
        </div>
    )
}

export default ProductAddonConfigListItem